export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const UPDATE_ONBOARDING_SUCESS = "UPDATE_ONBOARDING_SUCESS";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const SHOW_TOAST = "SHOW_TOAST";
export const STOP_TOAST = "STOP_TOAST";

export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const TC_CHECKED = "TC_CHECKED";

export const PHONE_AUTH = "PHONE_AUTH";
export const UPDATE_EDITED_DETAILS = "UPDATE_EDITED_DETAILS";
export const UPLOAD_PROFILE_IMAGE = "UPLOAD_PROFILE_IMAGE";

export const SET_DEFAULT_ADDRESS = "SET_DEFAULT_ADDRESS";

export const SET_SELECTED_VEHICLE_REF = "SET_SELECTED_VEHICLE_REF";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";

export const MODIFY_TOKEN = "MODIFY_TOKEN";
export const SAVE_WORKSHOP_STANDARD = "SAVE_WORKSHOP_STANDARD";
